module.exports = __webpack_public_path__ + "static/media/reny-1.b7ca9a45.jpg";